import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table-v6';
import '../../../../styles/custom.css';
import { CustomNoDataComponent, makeFirstLetterCapital,convertDateToDifferentTZ } from '../../../../utility/utility';
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import ReactTooltip from 'react-tooltip';
import * as actions from '../../../../redux/actions/index';
import { useSelector, useDispatch } from 'react-redux';
import { ClapSpinner } from 'react-spinners-kit';
import 'react-table-v6/react-table.css';
import { combineDateAndTime, convertDateUTCFormAudit, convertTimeStringToUTCFormAudit, convertTimeToUTCFormAudit, ConvertToFormat } from '../../../../utility/TimezoneOperations/timezoneUtility';
var moment = require('moment');

let RestroomPorteringTable = (props) => {

    const dispatch = useDispatch();
    // const SearchValue = useSelector(state => state.form.searchScheduledTask && state.form.searchScheduledTask.values ? state.form.searchScheduledTask.values : {});
    const DateGenerate = useSelector(state => state.LogBookReducer.dataGenerated);
    // const values = useSelector(state => state.LogBookReducer.scheduledTask_searchValues);
    const No_of_pages = useSelector(state => state.LogBookReducer.restroomPortering_total_pages);
    const No_of_rows = useSelector(state => state.LogBookReducer.restroomPortering_no_of_rows);
    const isRestroomPortering = useSelector(state => state.LogBookReducer.isRestroomPortering);
    const restroomPorteringCurPage = useSelector(state => state.LogBookReducer.restroomPorteringCurPage);
    const SearchOrResetScheduledTaskListClicked = useSelector(state => state.LogBookReducer.SearchOrResetScheduledTaskListClicked);

    const accountTimezone = 'America/Los_Angeles';

    const data = props.restroomPortering_list && props.restroomPortering_list.map((value) => {
        
        return {
            day_date: value.day_date ?  convertDateUTCFormAudit(value.day_date,"dddd, MM-DD-YYYY (z)"): '-',
            restroom: value && value.restroom ? value.restroom : '-',
            shift_hours: value && value.shift_hours ? `${moment(value.shift_hours, "HH:mm:ss").hour()} Hours` : '',
            in_time :  value && value.section ? convertTimeToUTCFormAudit(combineDateAndTime(ConvertToFormat( value.day_date,"MM/DD/YYYY"),value.section.in_time),"h:mm A (z)" ,"MM/DD/YYYY HH:mm:ss"): '',
            out_time :  value && value.section ? convertTimeToUTCFormAudit(combineDateAndTime(ConvertToFormat(value.day_date,"MM/DD/YYYY"),value.section.out_time), "h:mm A (z)","MM/DD/YYYY HH:mm:ss") : '',
            restroom_condition :  value && value.section ? value.section.restroom_condition : '',
            actions:
                <>
                <span className="mr_20 account_edit_icn" onClick={() => props.history.push(`rest-room-portering/view/${value.id}`)} ><i class="fas fa-eye" aria-hidden="true" ></i></span>
                {
                    props?.isCreateAccess ? <span className="mr_20 account_edit_icn"  onClick={() => props.history.push(`rest-room-portering/${value.id}`)} ><i class="fa fa-pencil" aria-hidden="true" ></i></span> : null
                }
                
                </>
        }
    })

    const columns = [
        {
            Header: <><span> Restroom </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'restroom',
            show: props.restroomPortering_list.length !== 0,
            width: 135,
        },
        {
            Header: <><span> Day & Date </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'day_date',
            show: props.restroomPortering_list.length !== 0,
            width: 235,
        },
        {
            Header: <><span> Shift Hours</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'shift_hours',
            show: props.restroomPortering_list.length !== 0,
            width: 235,
        },
        {
            Header: <><span> In Time</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'in_time',
            show: props.restroomPortering_list.length !== 0,
             width : 200,
        },
        {
            Header: <><span> Out Time </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'out_time',
            show: props.restroomPortering_list.length !== 0,
            width : 200,
        },
        {
            Header: <><span> Restroom Condition Crowd / Safety </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'restroom_condition',
            show: props.restroomPortering_list.length !== 0,
        },
        {
            Header: '',
            accessor: 'actions',
            width: 135,
            sortable:false,
        }
    ]

    

    const [tablePage, setTablePage] = useState(0)
    const tablePageNew =  React.useRef()
    if(restroomPorteringCurPage !== tablePageNew.current) {
        tablePageNew.current = restroomPorteringCurPage;
      }
    const setTablePageFn = (page) => {
        setTablePage(page)
        props.restroomPorteringPageClicked(page)
        tablePageNew.current = page;
    }

    const fetchData = (state, instance) => {
        if (SearchOrResetScheduledTaskListClicked) {
            dispatch(actions.resetSearchOrResetInventory())
        } else {
            if (!DateGenerate && !props.isRestroomPortering) {
                state.page = 2;
                const limit = state.pageSize;
                let page = tablePageNew.current >= 0 ? tablePageNew.current + 1 : restroomPorteringCurPage + 1;
                const inventoryItemsList_no_of_rows = state.pageSize;
                if(No_of_rows != inventoryItemsList_no_of_rows) {
                    page = 1;
                    setTablePageFn(0)
                }
                
                const order = state.sorted[0]?.id;
                const orderBy = state.sorted && state.sorted.length ? state.sorted[0]?.desc === true ? 'desc' : 'asc' : null;
                // const accountId = SearchValue.id ? SearchValue.id : null;
                // const taskName = SearchValue.name ? SearchValue.name : null;
                // const companyName = SearchValue.company ? SearchValue.company : null;
                // const accountName = SearchValue.job ? SearchValue.job : null;
                // const from = SearchValue.fromDate ? convertDateToDifferentTZ(SearchValue.fromDate, 'from') : null;
                // const to = SearchValue.toDate ? convertDateToDifferentTZ(SearchValue.toDate, 'to') : null;
                props.getAllRestroomPortering({page,limit, order, orderBy})
            }
        }
    }

    return (
        SearchOrResetScheduledTaskListClicked && props.isRestroomPortering ?
            <div  >
                <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />
            </div>
            :
            <ReactTable
                data={data}
                loading={props.isRestroomPortering}
                minRows={0}
                defaultPageSize={No_of_rows}
                pages={No_of_pages}
                gotoPage={restroomPorteringCurPage}
                page = { restroomPorteringCurPage }
                onPageChange={(page) => {setTablePageFn(page)}}
                // onPageSizeChange={props.onUserPageSizeChange}
                manual
                onFetchData={fetchData}
                showPaginationTop={true}
                showPaginationBottom={false}
                showPagination={props.restroomPortering_list.length !== 0}
                columns={columns}
                // style={{marginTop: '10px'}}
                NoDataComponent={() => CustomNoDataComponent(isRestroomPortering, 'No Restroom Portering List Found')}
                LoadingComponent={() =>
                    isRestroomPortering ?
                        <div style={{
                            display: "block",
                            position: "absolute",
                            left: 0,
                            height: '100%',
                            right: 0,
                            background: "rgba(255,255,255,0.8)",
                            transition: "all .3s ease",
                            top: 0,
                            bottom: 0,
                            textAlign: "center"
                        }}
                            className="loader_btn_block">
                            <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />
                        </div> : null}
                getTheadThProps={(state, rowInfo, column, instance) => {
                    // console.log(column);
                    return {
                        style: {
                            borderTop: 'none',
                            borderBottom: 'none',
                            borderRight: 'none',
                            textAlign: 'center',
                            color: '#566975',
                            fontSize: '14px',
                            fontWeight: '600',
                            whiteSpace: 'nowrap',
                            float: 'left',
                        }
                    }
                }
                }
                getTrProps={(state, rowInfo, column, instance) => {
                    // onclick = () => userDetail(rowInfo ? rowInfo.row.user : rowInfo);
                    console.log(column);
                    return {
                        className: 'react-table-tr-element',
                        style: {
                            border: '1px solid #c7cdd1',
                            transition: '.3s ease-in-out',
                            width: '100%',
                            // borderRadius: '4px',
                            // height: '80px',
                            marginTop: '5px',
                            float: 'left'
                        }
                    }

                }}
                getTdProps={(state, rowInfo, column, instance) => {

                    if (column.id == 'image') {
                        return {
                            style: {
                                marginTop: '0px'
                            }
                        }
                    } else {
                        return {
                            className: 'react-td-element',
                        }
                        //  {
                        //   style: {
                        //     borderTop: 'none',
                        //     verticalAlign: 'middle',
                        //     fontSize: '14px',
                        //     color: '#2b3034',
                        //     marginTop: '10px !important',
                        //     textAlign: 'center',
                        //   }
                        // }
                    }
                }
                }
                // getPaginationProps={() => {
                //     return {
                //         style: {
                //             marginTop: '50px',
                //             border: 'none',
                //             boxShadow: 'none'
                //         }
                //     }
                // }
                // }
                getProps={() => {
                    return {
                        style: {
                            border: 'none'
                        }
                    }
                }}
            />
    )
}

export default RestroomPorteringTable;